// Where one item of an approved campaign is up to. Emails and texts by what
// the server says happened to them (see serverStatus.js); posts and Stories,
// which the salon shares itself, by the clock.
import moment from 'moment'

// What useServerStatuses returns until the server has answered
export const LOADING = 'loading'

// Where one item is up to: { id, label, problem }. `made` is what approving
// created for it ({ channel, id }); `server` what useServerStatuses returned:
// LOADING while it's loading, null to go by the clock alone.
export const itemState = (it, made, server, now = new Date()) => {
  const gone = moment(it.at).isSameOrBefore(now)
  if (it.cancelled) return { id: 'cancelled', label: 'Cancelled' }
  if (!it.on) return { id: 'off', label: 'Left out' }
  if (!made) return { id: 'unscheduled', label: 'Not scheduled' }
  if (it.channel === 'post' || it.channel === 'story') return gone ? { id: 'due', label: 'Due to share' } : { id: 'planned', label: 'Planned' }
  // Still asking the server: never say it went before we know
  if (server === LOADING) return gone ? { id: 'checking', label: 'Checking…' } : { id: 'scheduled', label: 'Scheduled' }
  const s = server && made.id ? server[String(made.id)] : null
  // No answer (offline), or too old to be in the recent list: the clock, as before
  if (!s) return gone ? { id: 'sent', label: 'Sent' } : { id: 'scheduled', label: 'Scheduled' }
  switch (s.status) {
    case 'sent': return { id: 'sent', label: 'Sent' }
    case 'sending': return { id: 'sending', label: 'Sending' }
    case 'scheduled': return gone ? { id: 'sending', label: 'Going out' } : { id: 'scheduled', label: 'Scheduled' }
    case 'skipped': return { id: 'skipped', label: 'Called off: the times were taken', problem: true }
    case 'failed': return { id: 'failed', label: 'Couldn’t be sent', problem: true }
    case 'cancelled': return s.heldReason === 'interrupted'
      ? { id: 'stopped', label: 'Stopped part way: sending was interrupted', problem: true }
      : { id: 'stopped', label: 'Stopped part way', problem: true }
    // Deleted from the list after the fact: say what had happened to it (a
    // sent one is still sent). Older rows without archivedFrom: sent if
    // anyone got it.
    case 'archived':
      if (s.archivedFrom && s.archivedFrom !== 'archived') return itemState(it, made, { [String(made.id)]: { ...s, status: s.archivedFrom } }, now)
      if (s.deliveredCount > 0) return { id: 'sent', label: 'Sent' }
      return { id: 'deleted', label: 'Deleted', problem: true }
    case 'draft':
      if (s.heldReason === 'insufficient_credits') return { id: 'held', label: 'Not sent: balance too low', problem: true }
      if (s.heldReason === 'credit_check_failed') return { id: 'held', label: 'Not sent: balance couldn’t be checked', problem: true }
      if (s.heldReason === 'missed_send_time') return { id: 'held', label: 'Not sent: its time had passed', problem: true }
      if (s.heldReason) return { id: 'held', label: 'On hold', problem: true }
      return { id: 'unscheduled', label: 'Not scheduled', problem: true }
    default: return gone ? { id: 'sent', label: 'Sent' } : { id: 'scheduled', label: 'Scheduled' }
  }
}
